import {BiCustomize} from "react-icons/bi";
import {
  FaAddressCard,
  FaBell,
  FaFolderOpen,
  FaHome,
  FaSitemap,
  FaUserAlt,
  FaUsers,
} from "react-icons/fa";
import {MdGroupAdd, MdPermContactCalendar, MdWebhook} from "react-icons/md";
import HomePage from "./views/Home/HomePage";
import Profile from "./views/profile/Profile";
import Settings from "./views/Settings/settings.jsx";
import Login from "./views/Login";
import SitesContainer from "./views/Sites/sites";
import UsersList from "./views/Users/Users";
import Group from "./views/Group/Group";
import OrganizationAddress from "./views/Address/Address";
import Customers from "./views/Customers/Customers";
import Contacts from "./views/Contacts/contacts";
import Alerts from "./views/Alerts/Alerts";
import SensorAlerts from "./views/SensorAlerts/Alerts";
import ControllersDetails from "./layouts/ControllerLayout";
import AlertHistory from "./views/Alerts/AlertHistory";
import CustomFields from "./views/CustomFields";
import CustomFieldChoices from "./views/CustomFieldChoices";
import DashboardPage from "./views/Dashboard/DashboardPage";
import Reports from "./views/Reports";
import SensorAlertHistory from "./views/SensorAlerts/SensorAlertHistory";
import WebHooks from "./views/webhooks";
import DeliveryLogs from "./views/webhooks/deliveryLogs";
import EventRulesPage from "./views/eventRules";
//the components for controller layout are imported in controllerLayout component

export const routes = [
  {
    layout: "/auth",
    path: "/login",
    name: "Login",
    component: Login,
    showInSideNav: false,
  },
  {
    layout: "/app",
    path: "/home",
    name: "Home",
    icon: FaHome,
    component: HomePage,
    showInSideNav: true,
    customerDependency: false,
  },
  {
    layout: "/app",
    path: "/dashboards/:dashboardId",
    name: "Dashboard",
    component: DashboardPage,
    showInSideNav: false,
  },
  {
    key: "customer",
    path: "/customer",
    name: "Customer",
    icon: FaUserAlt,
    component: Customers,
    layout: "/app",
    showInSideNav: true,
    customerDependency: false,
  },
  {
    path: null,
    name: "Sites",
    icon: FaSitemap,
    component: HomePage,
    layout: "/app",
    showInSideNav: true,
    customerDependency: true,
    linkType: "dropdown",
    activeRouteOptions: ["sites", "appliance"],
    dropdownOptions: [
      {
        name: "View All Sites",
        link: null,
        layout: "app",
        key: "viewSites",
      },
      {
        name: "Create Site",
        link: null,
        layout: "app",
        key: "createSites",
        perms: ["add_site"],
      },
    ],
  },
  {
    path: "/sites/:siteId",
    name: "Sites",
    component: SitesContainer,
    layout: "/app",
    showInSideNav: false,
    customerDependency: true,
  },
  {
    path: "/appliance/:controllerId/*",
    name: "Controllers Details",
    component: ControllersDetails,
    layout: "/app",
    showInSideNav: false,
    customerDependency: true,
  },
  {
    name: "Reports",
    key: "reports",
    layout: "/app",
    path: "/reports/*",
    icon: FaFolderOpen,
    component: Reports,
    showInSideNav: true,
    customerDependency: true,
  },
  {
    key: "user",
    path: "/users",
    name: "Users",
    icon: FaUsers,
    component: UsersList,
    layout: "/app",
    showInSideNav: true,
    customerDependency: true,
  },
  {
    key: "group",
    path: "/groups",
    name: "Groups",
    icon: MdGroupAdd,
    component: Group,
    layout: "/app",
    showInSideNav: true,
    customerDependency: true,
  },
  {
    path: null,
    name: "Alerts",
    icon: FaBell,
    layout: "/app",
    linkType: "dropdown",
    showInSideNav: true,
    customerDependency: true,
    activeRouteOptions: [
      "system-alerts",
      "system-alert-history",
      "sensor-alerts",
      "sensor-alert-history",
    ],
    dropdownOptions: [
      {
        name: "System Alerts",
        link: "/system-alerts",
        layout: "/app",
        key: "systemalerts",
      },
      {
        name: "Sensor Alerts",
        link: "/sensor-alerts",
        layout: "/app",
        key: "sensoralerts",
      },
    ],
  },
  {
    name: "System Alerts",
    path: "/system-alerts",
    layout: "/app",
    component: Alerts,
    key: "systemalerts",
    showInSideNav: false,
    customerDependency: true,
  },
  {
    name: "Sensor Alerts",
    path: "/sensor-alerts",
    layout: "/app",
    component: SensorAlerts,
    key: "sensoralerts",
    showInSideNav: false,
    customerDependency: true,
  },
  {
    path: "/sensor-alert-history/:alertId",
    name: "Alerts History",
    component: SensorAlertHistory,
    layout: "/app",
    showInSideNav: false,
  },
  {
    path: "/system-alert-history/:alertId",
    name: "Alerts History",
    component: AlertHistory,
    layout: "/app",
    showInSideNav: false,
  },
  {
    key: "contact",
    path: "/contacts",
    name: "Contacts",
    icon: MdPermContactCalendar,
    component: Contacts,
    layout: "/app",
    showInSideNav: true,
    customerDependency: true,
  },
  {
    path: null,
    name: "Operations",
    icon: MdWebhook,
    layout: "/app",
    linkType: "dropdown",
    showInSideNav: true,
    customerDependency: true,
    activeRouteOptions: ["webhooks", "webhook-delivery-logs", "eventRules"],
    dropdownOptions: [
      {
        key: "webhooks",
        link: "/webhooks",
        name: "Webhooks",
        layout: "/app",
      },
      {
        key: "eventRules",
        link: "/eventRules",
        name: "Event Rules",
        layout: "/app",
      },
    ],
  },

  {
    key: "webhooks",
    path: "/webhooks",
    name: "Webhooks",
    layout: "/app",
    component: WebHooks,
    showInSideNav: false,
    customerDependency: true,
  },
  {
    key: "eventRules",
    path: "/eventRules",
    name: "Event Rules",
    layout: "/app",
    component: EventRulesPage,
    showInSideNav: false,
    customerDependency: true,
  },
  {
    path: "/webhook-delivery-logs/:webhookId",
    name: "Webhook Delivery Logs",
    component: DeliveryLogs,
    layout: "/app",
    showInSideNav: false,
  },

  {
    key: "customFields",
    path: "/custom-fields",
    name: "Custom Fields",
    layout: "/app",
    component: CustomFields,
    showInSideNav: false,
    customerDependency: true,
  },
  {
    key: "customFieldChoices",
    path: "/custom-field-choices",
    name: "Custom Field Choices",
    layout: "/app",
    component: CustomFieldChoices,
    showInSideNav: false,
    customerDependency: true,
  },
  {
    path: null,
    name: "Customization",
    icon: BiCustomize,
    layout: "/app",
    linkType: "dropdown",
    showInSideNav: true,
    customerDependency: true,
    activeRouteOptions: ["custom-fields", "custom-field-choices"],
    dropdownOptions: [
      {
        key: "customFields",
        link: "/custom-fields",
        name: "Custom Fields",
        layout: "/app",
      },
      {
        key: "customFieldChoices",
        link: "/custom-field-choices",
        name: "Custom Field Choices",
        layout: "/app",
      },
    ],
  },
  {
    name: "Organization Address",
    path: "/organizationAddress",
    icon: FaAddressCard,
    layout: "/app",
    component: OrganizationAddress,
    showInSideNav: true,
    customerDependency: true,
  },
  {
    path: "/user-profile",
    name: "User Profile",
    component: Profile,
    showInSideNav: false,
    layout: "/app",
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    showInSideNav: false,
    layout: "/app",
  },
];

export const authRoutes = routes.filter((route) => route.layout === "/auth");
export const appRoutes = routes.filter((route) => route.layout === "/app");

export const sideBarRoutes = (isCustomerSelected) =>
  routes.filter((route) => {
    if (isCustomerSelected) {
      return route.showInSideNav;
    } else {
      return route.showInSideNav && !route.customerDependency;
    }
  });
